import React from 'react';

const AboutText = () => {
    return (
        <section className="about_section">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <figure>
                            <figcaption className="about_content">
                                <h1>Добро пожаловать в нашу компанию!</h1>
                                <p className="about_content_left">Мы — ваш надежный партнер по поставке высококачественных пиломатериалов для строительства, отделки и ремонта.
                                    Наш ассортимент предлагает широкий выбор материалов, которые отвечают самым строгим стандартам качества.</p>
                                <p className="about_content_left">
                                    <h4>Наш ассортимент</h4>
                                    <ul>
                                        <li><b>Доска строганная</b> — идеальна для отделочных работ, строительства мебели и декоративных элементов.</li>

                                        <li><b>Брусок строганный</b> — прочный и надежный материал для создания каркасов, обрешеток и других конструкционных элементов.</li>

                                        <li><b>Доска обрезная</b> — универсальный материал для строительства и хозяйственных нужд.</li>

                                        <li><b>Блок-хаус</b> — практичное и стильное решение для облицовки стен и фасадов.</li>

                                        <li><b>Имитация бруса</b> — создает эффект массивной деревянной стены при меньшей нагрузке на конструкцию.</li>

                                        <li><b>Штиль</b> — современный вид обшивочной доски с ровной поверхностью и четкими краями.</li>

                                        <li><b>Доска пола</b> — прочный и долговечный материал для устройства полов в жилых и коммерческих помещениях.</li>

                                        <li><b>Евровагонка</b> — классическое решение для внутренней и наружной отделки с идеальной геометрией и удобством монтажа.</li>
                                    </ul>

                                    <h4>Почему выбирают нас?</h4>
                                    <ul>
                                        <li><b>Высокое качество:</b> Мы тщательно отбираем материалы, чтобы обеспечить надежность и долговечность продукции.</li>

                                        <li><b>Широкий ассортимент:</b> У нас вы найдете все необходимые пиломатериалы для своих проектов.</li>

                                        <li><b>Консультации и помощь:</b> Наши специалисты всегда готовы помочь с выбором продукции и предложить оптимальные решения.</li>

                                        <li><b>Доступные цены:</b> Мы предлагаем конкурентоспособные цены без потери качества.</li>
                                    </ul>

                                    <h4>Мы ценим ваше доверие</h4>

                                    Наша компания дорожит своей репутацией и стремится к долгосрочному сотрудничеству с каждым клиентом. Мы уверены, что наши пиломатериалы помогут воплотить ваши проекты в жизнь с максимальной точностью и надежностью.

                                    Свяжитесь с нами сегодня и убедитесь, что качественная древесина — залог успешного строительства и ремонта!
                                </p>
                            </figcaption>
                        </figure>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutText;